export function addQueryParam({
  url,
  key,
  val
}) {
  let separator = '?';
  if (url.includes('?') && !url.endsWith('?') && !url.endsWith('&')) {
    separator = '&';
  } else if (url.endsWith('?') || url.endsWith('&')) {
    separator = '';
  }
  return `${url}${separator}${key}=${val}`;
}